/**
 * Meta Facebook App ID，须与 Firebase Console → Authentication → Facebook 为同一应用。
 */
export function getFacebookAppId(): string {
    const appId = '2159073668213781';
    return appId;
}
